const headers = [{
    text: "Ocupação",
    align: "center",
    value: "occupation"
  },
  {
    text: "CBO",
    align: "center",
    value: "cbo"
  },
  {
    text: "Salário Base (R$)",
    align: "center",
    value: "basicSalary"
  },
  {
    text: "Gratificação de Função (R$)",
    align: "center",
    value: "value"
  },
  {
    text: "Ação",
    align: "center",
    value: ""
  }
];
const headersConvention = [{
    text: "Ano",
    align: "center",
    value: "year"
  },
  {
    text: "Código",
    align: "center",
    value: "code"
  },
  {
    text: "Situação",
    align: "center",
    value: "active",
    sortable: false
  },
  {
    text: "Ação",
    align: "center",
    value: "",
    sortable: false
  }
];
const headersServiceStations = [{
    text: "Descrição",
    align: "center",
    value: "description"
  },
  {
    text: "Valor (R$)",
    align: "center",
    value: "value"
  },
  {
    text: "Ação",
    align: "center",
    value: ""
  }
];
const headersDataTableCosts = [{
    text: "Descrição",
    align: "center",
    value: "description"
  },
  {
    text: "Valor (R$)",
    align: "center",
    value: "value"
  },
  {
    text: "Observações",
    align: "center",
    value: "observation"
  },
  {
    text: "Ação",
    align: "center",
    value: ""
  }
];
class Headers{
  static getHeaders(){
    return headers;
  }
  static getHeadersConvention(){
    return headersConvention;
  }
  static getHeadersServiceStations(){
    return headersServiceStations;
  }
  static getHeadersDataTableCosts(){
    return headersDataTableCosts;
  }
}
export default Headers;



// WEBPACK FOOTER //
// ./src/data/headers/CollectiveConventionHeaders.js